import { API2 } from "@/lib/api";

export const getWFSAuthLink = async (): Promise<{ url: string }> => {
    return API2.get("/wfs/auth_link");
};

export const handleWFSCallback = async (code: string, state: string, sellerId: string, type: string, partnerType: string): Promise<void> => {
    return API2.post("/wfs/auth_callback", { code, state, sellerId, type, partnerType });
};

export const disconnectWFS = async (): Promise<void> => {
    return API2.post("/wfs/disconnect");
};
